import React, { useState } from 'react';
import { motion, useMotionTemplate, useMotionValue } from 'framer-motion';
import { FolderGit2, Rocket, Trophy } from 'lucide-react';
import './Card.css';

const Card = ({ name, shortDescription, codeUrl, techStack, awards, devpost }) => {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  const [isHovered, setIsHovered] = useState(false);

  function handleMouseMove({ currentTarget, clientX, clientY }) {
    const { left, top } = currentTarget.getBoundingClientRect();
    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  }

  return (
    <motion.div 
      className="project-card"
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      whileHover={{ y: -8, scale: 1.02, transition: { duration: 0.2, ease: "easeOut" } }}
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      <motion.div
        className="card-spotlight"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: useMotionTemplate`
            radial-gradient(
              400px circle at ${mouseX}px ${mouseY}px,
              rgba(99, 102, 241, 0.15),
              transparent 80%
            )
          `,
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
          zIndex: 0
        }}
      />
      <div className="card-header relative" style={{ zIndex: 1 }}>
        <h3 className="project-name">{name}</h3>
      </div>
      <p className="project-description relative" style={{ zIndex: 1 }}>{shortDescription}</p>

      <div className="tech-stack relative" style={{ zIndex: 1 }}>
        {techStack.split(',').map((tech, index) => (
          <motion.span 
            key={index} 
            className="tech-tag"
            whileHover={{ y: -2, backgroundColor: "var(--surface-color)", borderColor: "var(--primary-light)" }}
          >
            {tech.trim()}
          </motion.span>
        ))}
      </div>

      {awards && (
        <div className="awards-container relative" style={{ zIndex: 1 }}>
          <div className="award-item">
            <Trophy size={16} />
            <span>{awards}</span>
          </div>
        </div>
      )}

      <div className="card-footer relative" style={{ zIndex: 1 }}>
        {codeUrl && (
          <motion.a
            href={codeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="card-link"
            whileHover={{ y: -2, color: "var(--primary-color)", backgroundColor: "var(--tech-tag-bg)" }}
          >
            <FolderGit2 size={16} />
            <span>GitHub</span>
          </motion.a>
        )}
        {devpost && (
          <motion.a
            href={devpost}
            target="_blank"
            rel="noopener noreferrer"
            className="card-link"
            whileHover={{ y: -2, color: "var(--primary-color)", backgroundColor: "var(--tech-tag-bg)" }}
          >
            <Rocket size={16} />
            <span>Devpost</span>
          </motion.a>
        )}
      </div>
    </motion.div>
  );
};

export default Card;

